<template>
  <v-row
    dense
    class="elevation-1 px-4 mx-1 mb-6 py-4 my-5 grey lighten-2"
  >
    <v-col cols="12">
      <h3 class="pa-3">{{ label }}:</h3>
    </v-col>
    <v-col cols="12">
      <v-chip
        v-for="val in possibleValues"
        @click="chooseElementParameter(val)"
        :key="val"
        :color="value===val ? 'primary' : 'white'"
        :class="`px-5 pt-0 mr-1 my-1 font-weight-bold ${value===val ? 'white' : 'primary'}--text`"
        link
      >
        {{ $t(`scenario.${val}`) }}
      </v-chip>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'ChooseElementParameters',

  props: {
    possibleValues: {
      type: Array,
      required: true,
      default: () => [],
    },
    value: {
      type: String,
      required: true,
      default: '',
    },
    label: {
      type: String,
      required: true,
      default: '',
    },
  },

  methods: {
    chooseElementParameter (obtaining) {
      this.$emit('chooseElementParameter', obtaining);
    },
  },
}
</script>